$(document).ready(function(){

  $(document).on('click', '.add-new-address-button', function() {
    $('.address-modal').addClass('address-modal-active');
    $('.address-overlay').addClass('address-overlay-active');
    $('body').addClass('overflow-hidden');
  });
  
   $(document).on('click', '.address-overlay', function() {
    $('.address-modal').removeClass('address-modal-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
  
  $(document).on('click', '.address-edit-button', function() {
    $('.edit-model').addClass('edit-model-active');
    $('.address-overlay').addClass('address-overlay-active');
    $('body').addClass('overflow-hidden');
  });
  
  $(document).on('click', '.button-cancle', function() {
    $('.address-modal').removeClass('address-modal-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
  
  $(document).on('click', '.edit-address-cancel-button', function() {
    $('.edit-model').removeClass('edit-model-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
  
   $(document).on('click', '.drawer-close-icon', function() {
    $('.address-modal').removeClass('address-modal-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
  
  $(document).on('click', '.edit-drawer-close-icon', function() {
    $('.edit-model').removeClass('edit-model-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
  
  $(document).on('click', '.address-overlay', function() {
    $('.edit-model').removeClass('edit-model-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });
     
  $(document).on('click', '.edit-cancle', function() {
    $('.edit-model').removeClass('edit-model-active');
    $('.address-overlay').removeClass('address-overlay-active');
    $('body').removeClass('overflow-hidden');
  });

});